import { ContactView } from '~/components/contact/ContactView';

export default function ViewContactRoute() {
  return <ContactView />;
}
